import Icon from './Icon'

export default function GooglePlayIcon({ className }: { className: string }) {
  return (
    <Icon
      className={className}
      icon={
        <svg
          viewBox="0 0 136 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3731_62148)">
            <path
              d="M130.664 40H5.66406C2.86406 40 0.664062 37.8 0.664062 35V5C0.664062 2.2 2.86406 0 5.66406 0H130.664C133.464 0 135.664 2.2 135.664 5V35C135.664 37.8 133.464 40 130.664 40Z"
              fill="black"
            />
            <path
              d="M130.664 0.8C132.964 0.8 134.864 2.7 134.864 5V35C134.864 37.3 132.964 39.2 130.664 39.2H5.66406C3.36406 39.2 1.46406 37.3 1.46406 35V5C1.46406 2.7 3.36406 0.8 5.66406 0.8H130.664ZM130.664 0H5.66406C2.86406 0 0.664062 2.3 0.664062 5V35C0.664062 37.8 2.86406 40 5.66406 40H130.664C133.464 40 135.664 37.8 135.664 35V5C135.664 2.3 133.464 0 130.664 0Z"
              fill="#A6A6A6"
            />
            <path
              d="M68.764 21.8C66.364 21.8 64.464 23.6 64.464 26.1C64.464 28.5 66.364 30.4 68.764 30.4C71.164 30.4 73.064 28.6 73.064 26.1C73.064 23.5 71.164 21.8 68.764 21.8ZM68.764 28.6C67.464 28.6 66.364 27.5 66.364 26C66.364 24.5 67.464 23.4 68.764 23.4C70.064 23.4 71.164 24.4 71.164 26C71.164 27.5 70.064 28.6 68.764 28.6ZM59.464 21.8C57.064 21.8 55.164 23.6 55.164 26.1C55.164 28.5 57.064 30.4 59.464 30.4C61.864 30.4 63.764 28.6 63.764 26.1C63.764 23.5 61.864 21.8 59.464 21.8ZM59.464 28.6C58.164 28.6 57.064 27.5 57.064 26C57.064 24.5 58.164 23.4 59.464 23.4C60.764 23.4 61.864 24.4 61.864 26C61.864 27.5 60.764 28.6 59.464 28.6ZM48.364 23.1V24.9H52.664C52.564 25.9 52.164 26.7 51.664 27.2C51.064 27.8 50.064 28.5 48.364 28.5C45.664 28.5 43.664 26.4 43.664 23.7C43.664 21 45.764 18.9 48.364 18.9C49.764 18.9 50.864 19.5 51.664 20.2L52.964 18.9C51.864 17.9 50.464 17.1 48.464 17.1C44.864 17.1 41.764 20.1 41.764 23.7C41.764 27.3 44.864 30.3 48.464 30.3C50.464 30.3 51.864 29.7 53.064 28.4C54.264 27.2 54.664 25.5 54.664 24.2C54.664 23.8 54.664 23.4 54.564 23.1H48.364ZM93.764 24.5C93.364 23.5 92.364 21.8 90.164 21.8C87.964 21.8 86.164 23.5 86.164 26.1C86.164 28.5 87.964 30.4 90.364 30.4C92.264 30.4 93.464 29.2 93.864 28.5L92.464 27.5C91.964 28.2 91.364 28.7 90.364 28.7C89.364 28.7 88.764 28.3 88.264 27.4L93.964 25L93.764 24.5ZM87.964 25.9C87.964 24.3 89.264 23.4 90.164 23.4C90.864 23.4 91.564 23.8 91.764 24.3L87.964 25.9ZM83.264 30H85.164V17.5H83.264V30ZM80.264 22.7C79.764 22.2 78.964 21.7 77.964 21.7C75.864 21.7 73.864 23.6 73.864 26C73.864 28.4 75.764 30.2 77.964 30.2C78.964 30.2 79.764 29.7 80.164 29.2H80.264V29.8C80.264 31.4 79.364 32.3 77.964 32.3C76.864 32.3 76.064 31.5 75.864 30.8L74.264 31.5C74.764 32.6 75.964 34 78.064 34C80.264 34 82.064 32.7 82.064 29.6V22H80.264V22.7ZM78.064 28.6C76.764 28.6 75.664 27.5 75.664 26C75.664 24.5 76.764 23.4 78.064 23.4C79.364 23.4 80.364 24.5 80.364 26C80.364 27.5 79.364 28.6 78.064 28.6ZM102.464 17.5H97.964V30H99.864V25.3H102.464C104.564 25.3 106.564 23.8 106.564 21.4C106.564 19 104.564 17.5 102.464 17.5ZM102.564 23.5H99.864V19.2H102.564C103.964 19.2 104.764 20.4 104.764 21.3C104.664 22.4 103.864 23.5 102.564 23.5ZM114.064 21.7C112.664 21.7 111.264 22.3 110.764 23.6L112.464 24.3C112.864 23.6 113.464 23.4 114.164 23.4C115.164 23.4 116.064 24 116.164 25V25.1C115.864 24.9 115.064 24.6 114.264 24.6C112.464 24.6 110.664 25.6 110.664 27.4C110.664 29.1 112.164 30.2 113.764 30.2C115.064 30.2 115.664 29.6 116.164 29H116.264V30H118.064V25.2C117.864 23 116.164 21.7 114.064 21.7ZM113.864 28.6C113.264 28.6 112.364 28.3 112.364 27.5C112.364 26.5 113.464 26.2 114.364 26.2C115.164 26.2 115.564 26.4 116.064 26.6C115.864 27.8 114.864 28.6 113.864 28.6ZM124.364 22L122.264 27.4H122.164L119.964 22H117.964L121.264 29.6L119.364 33.8H121.264L126.364 22H124.364ZM107.564 30H109.464V17.5H107.564V30Z"
              fill="white"
            />
            <path
              d="M11.0641 7.5C10.7641 7.8 10.6641 8.3 10.6641 8.9V31C10.6641 31.6 10.8641 32.1 11.1641 32.4L11.2641 32.5L23.6641 20.1V20V19.9L11.0641 7.5Z"
              fill="url(#paint0_linear_3731_62148)"
            />
            <path
              d="M27.6641 24.3L23.5641 20.2V20V19.9L27.6641 15.8L27.7641 15.9L32.6641 18.7C34.0641 19.5 34.0641 20.8 32.6641 21.6L27.6641 24.3Z"
              fill="url(#paint1_linear_3731_62148)"
            />
            <path
              d="M27.7641 24.2L23.5641 20L11.0641 32.5C11.5641 33 12.2641 33 13.1641 32.6L27.7641 24.2Z"
              fill="url(#paint2_linear_3731_62148)"
            />
            <path
              d="M27.7641 15.8L13.1641 7.5C12.2641 7 11.5641 7.1 11.0641 7.6L23.5641 20L27.7641 15.8Z"
              fill="url(#paint3_linear_3731_62148)"
            />
            <path
              opacity="0.2"
              d="M27.6641 24.1L13.1641 32.3C12.3641 32.8 11.6641 32.7 11.1641 32.3L11.0641 32.4L11.1641 32.5C11.6641 32.9 12.3641 33 13.1641 32.5L27.6641 24.1Z"
              fill="black"
            />
            <path
              opacity="0.12"
              d="M11.0641 32.3C10.7641 32 10.6641 31.5 10.6641 30.9V31C10.6641 31.6 10.8641 32.1 11.1641 32.4V32.3H11.0641Z"
              fill="black"
            />
            <path
              opacity="0.12"
              d="M32.6641 21.3L27.6641 24.1L27.7641 24.2L32.6641 21.4C33.3641 21 33.6641 20.5 33.6641 20C33.6641 20.5 33.2641 20.9 32.6641 21.3Z"
              fill="black"
            />
            <path
              opacity="0.25"
              d="M13.1641 7.6L32.6641 18.7C33.2641 19.1 33.6641 19.5 33.6641 20C33.6641 19.5 33.3641 19 32.6641 18.6L13.1641 7.5C11.7641 6.7 10.6641 7.3 10.6641 8.9V9C10.6641 7.5 11.7641 6.8 13.1641 7.6Z"
              fill="white"
            />
            <path
              d="M43.664 13.1C43.264 13.1 42.864 13 42.564 12.7C42.264 12.5 42.064 12.1 41.864 11.7L42.564 11.4C42.764 12 43.064 12.3 43.664 12.3C44.064 12.3 44.264 12.2 44.464 12C44.664 11.8 44.764 11.5 44.764 11.1V7H45.564V11.1C45.564 11.8 45.364 12.3 45.064 12.6C44.664 13 44.264 13.1 43.664 13.1Z"
              fill="white"
              stroke="white"
              strokeWidth="0.2"
              strokeMiterlimit="10"
            />
            <path
              d="M50.364 7.7H47.664V9.6H50.164V10.3H47.664V12.2H50.364V13H46.864V7H50.364V7.7Z"
              fill="white"
              stroke="white"
              strokeWidth="0.2"
              strokeMiterlimit="10"
            />
            <path
              d="M53.6641 13H52.8641V7.7H51.1641V7H55.2641V7.7H53.6641V13Z"
              fill="white"
              stroke="white"
              strokeWidth="0.2"
              strokeMiterlimit="10"
            />
            <path
              d="M55.964 13V12.2L59.164 7.7H56.064V7H60.064V7.8L56.864 12.3H60.064V13H55.964Z"
              fill="white"
              stroke="white"
              strokeWidth="0.2"
              strokeMiterlimit="10"
            />
            <path
              d="M63.1641 13H62.3641V7.7H60.6641V7H64.7641V7.7H63.0641V13H63.1641Z"
              fill="white"
              stroke="white"
              strokeWidth="0.2"
              strokeMiterlimit="10"
            />
            <path
              d="M67.864 13V7H70.064C70.564 7 70.964 7.2 71.264 7.5C71.564 7.8 71.764 8.2 71.764 8.7C71.764 9 71.664 9.2 71.564 9.5C71.464 9.7 71.264 9.9 70.964 10C71.264 10.1 71.464 10.3 71.664 10.5C71.864 10.7 71.964 11 71.964 11.4C71.964 11.9 71.764 12.3 71.464 12.6C71.064 12.8 70.664 13 70.164 13H67.864ZM68.664 9.6H70.064C70.364 9.6 70.564 9.5 70.764 9.3C70.964 9.1 71.064 8.9 71.064 8.7C71.064 8.5 70.964 8.2 70.764 8C70.564 7.8 70.364 7.7 70.064 7.7H68.664V9.6ZM68.664 12.3H70.264C70.564 12.3 70.764 12.2 70.964 12C71.164 11.8 71.264 11.6 71.264 11.3C71.264 11.1 71.164 10.8 70.964 10.6C70.764 10.4 70.564 10.3 70.264 10.3H68.664V12.3Z"
              fill="white"
              stroke="white"
              strokeWidth="0.2"
              strokeMiterlimit="10"
            />
            <path
              d="M76.564 7.7H73.864V9.6H76.364V10.3H73.864V12.2H76.564V13H73.064V7H76.564V7.7Z"
              fill="white"
              stroke="white"
              strokeWidth="0.2"
              strokeMiterlimit="10"
            />
            <path
              d="M77.764 13V7H78.564V13H77.764Z"
              fill="white"
              stroke="white"
              strokeWidth="0.2"
              strokeMiterlimit="10"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_3731_62148"
              x1="22.4637"
              y1="8.7098"
              x2="5.68126"
              y2="25.4922"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#00A0FF" />
              <stop offset="0.00657445" stopColor="#00A1FF" />
              <stop offset="0.2601" stopColor="#00BEFF" />
              <stop offset="0.5122" stopColor="#00D2FF" />
              <stop offset="0.7604" stopColor="#00DFFF" />
              <stop offset="1" stopColor="#00E3FF" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_3731_62148"
              x1="34.4984"
              y1="20.0015"
              x2="10.3015"
              y2="20.0015"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFE000" />
              <stop offset="0.4087" stopColor="#FFBD00" />
              <stop offset="0.7754" stopColor="#FFA500" />
              <stop offset="1" stopColor="#FF9C00" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_3731_62148"
              x1="25.491"
              y1="22.2962"
              x2="2.73269"
              y2="45.0545"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF3A44" />
              <stop offset="1" stopColor="#C31162" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_3731_62148"
              x1="7.96129"
              y1="0.176299"
              x2="18.1239"
              y2="10.3388"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#32A071" />
              <stop offset="0.0685" stopColor="#2DA771" />
              <stop offset="0.4762" stopColor="#15CF74" />
              <stop offset="0.8009" stopColor="#06E775" />
              <stop offset="1" stopColor="#00F076" />
            </linearGradient>
            <clipPath id="clip0_3731_62148">
              <rect
                width="135"
                height="40"
                fill="white"
                transform="translate(0.664062)"
              />
            </clipPath>
          </defs>
        </svg>
      }
    />
  )
}
